import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { map } from 'rxjs/operators';
import { File } from '../models/file';

@Injectable({providedIn: 'root'})
export class FileApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {}

  async upload(fileData: any, filename?: string, width?: number, height?: number): Promise<File> {
    let params = new HttpParams();
    if (width && height) {
      params = params.set('width', width.toString()).set('height', height.toString());
    }

    const formData = new FormData();
    formData.append('file', fileData, filename);
    return this.httpClient
      .post(`${this.configService.get('apiUrl')}/api/v1/file/`, formData, {params})
      .pipe(map(data => File.toFront(data)))
      .toPromise();
  }

  async createZipArchive(files: {file: any, filename: string}[]): Promise<any> {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file.file, file.filename);
    }
    return this.httpClient
      .post(`${this.configService.get('apiUrl')}/api/v1/file/zip_archive/`, formData, {responseType: 'blob'})
      .toPromise();
  }
}
